import i18n from '../i18n';
import ReactDOM from 'react-dom';

import { SnackbarProvider, withSnackbar } from 'notistack';

export const Notification = {
  // types: 
  // default
  // success
  // warning
  // info
  // error
  pushNotif(text = i18n.t("Notification.Wrong"), type = "default", duration = 3500) {
    const Display = withSnackbar(({ message, enqueueSnackbar }) => {
      enqueueSnackbar(message, {
        autoHideDuration: duration,
        variant: type,

        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
      return null;
    });

    const mountPoint = document.getElementById('snackbarHelper');
    ReactDOM.render(
      <SnackbarProvider dense={false} maxSnack={3} preventDuplicate anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}>
        <Display message={text} />
      </SnackbarProvider>,
      mountPoint)
  },
};